module.exports = __webpack_public_path__ + "img/deletion-warning.74621ade.svg";